module.exports = __webpack_public_path__ + "assets/webgl/Ceramic_base.1001.d73c4f9c.jpg";